import { render, staticRenderFns } from "./Typebot.vue?vue&type=template&id=12573160&scoped=true&"
import script from "./Typebot.vue?vue&type=script&lang=js&"
export * from "./Typebot.vue?vue&type=script&lang=js&"
import style0 from "./Typebot.vue?vue&type=style&index=0&id=12573160&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12573160",
  null
  
)

export default component.exports